import {Box, Chip, ListItemButton, ListItemIcon, Typography} from '@mui/material'
import {ChevronRight} from '@mui/icons-material'
import {PortalNotificationReference} from '../../../types'
import {getMostRecentActivityDate, getMostRecentContent, hasUnreadReplies, stripHtml} from '../../../utils'
import {LinkWithSearchParams} from '../../shared'
import dayjs from 'dayjs'

export function MessageListItem({
  notification,
  isLast,
}: {
  notification: PortalNotificationReference;
  isLast: boolean;
}) {
  const isUnread = !notification.ReadReceipt || hasUnreadReplies(notification)
  const unreadReplies = hasUnreadReplies(notification)
  const date = dayjs(getMostRecentActivityDate(notification)).format('MMM D, YYYY h:mm A')
  const previewContent = stripHtml(getMostRecentContent(notification))

  return (
    <ListItemButton
      component={LinkWithSearchParams}
      to={notification.NotificationId}
      sx={{
        borderBottom: isLast ? 'none' : '1px solid #ddd',
        p: 2,
        '&:hover': {color: 'initial', backgroundColor: '#ddd'},
      }}
    >
      {isUnread && (
        <Box
          sx={{
            width: 8,
            height: 8,
            bgcolor: 'primary.main',
            mr: 1.5,
            flexShrink: 0,
            alignSelf: 'center',
          }}
        />
      )}
      <Box sx={{flex: 1, minWidth: 0}}>
        <Typography noWrap fontWeight={isUnread ? 700 : 400}>
          {notification.NotificationTitle}
        </Typography>
        <Typography noWrap variant="body2" color="text.secondary">
          {previewContent}
        </Typography>
        <Typography variant="teeny" sx={{letterSpacing: '0.1px', color: '#ABABAF'}}>
          {date}
        </Typography>
      </Box>
      {(notification.Replies?.length ?? 0) > 0 && (
        <Chip
          label={`${notification.Replies!.length} ${notification.Replies!.length > 1 ? 'Replies' : 'Reply'}`}
          size="small"
          sx={{
            ml: 1,
            flexShrink: 0,
            bgcolor: unreadReplies ? 'primary.main' : 'grey.300',
            color: unreadReplies ? 'primary.contrastText' : 'text.secondary',
            fontWeight: 600,
            height: 20,
            fontSize: '0.7rem',
            '.MuiChip-label': { px: '6px' },
          }}
        />
      )}
      <ListItemIcon sx={{ml: 1, minWidth: 0, color: 'primary.main'}}>
        <ChevronRight/>
      </ListItemIcon>
    </ListItemButton>
  )
}
